import { v4 as uuid } from 'uuid';

const config = {
  socketUrl: process.env.REACT_APP_API_ENDPOINT,
  instanceKey: uuid(),
  price: 9
};

export default config;